export default {
  name: 'tooltip',
  methods: {
    spTooltipConfig(message) {
      return {
        content: `${message}<div class="tooltip-close"></div>`,
        trigger: 'click',
        offset: -100,
        autoHide: false,
        hideOnTargetClick: false,
        template: '<div class="tooltip2 tooltip-sp" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      }
    },
    pcTooltipConfig(message) {
      return {
        enabled: false,
        content: message,
        autoHide: false,
        trigger: 'focus hover',
        hideOnTargetClick: false,
        template: '<div class="tooltip2 tooltip-pc" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      }
    },
  },
}
